import { render, staticRenderFns } from "./BranchChart.vue?vue&type=template&id=32045d88&"
import script from "./BranchChart.vue?vue&type=script&lang=js&"
export * from "./BranchChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports